import { render } from "./NewsHoldingDate.vue?vue&type=template&id=55dca92e"
import script from "./NewsHoldingDate.vue?vue&type=script&lang=js"
export * from "./NewsHoldingDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__